import React, { Component } from 'react'
import { Row, Col, Card, Image, Container,Button } from 'react-bootstrap';
import { withRouter } from "react-router-dom";
import * as Cookies from "es-cookie";
import NavbarTop from '../components/login_register/NavbarTop';
import Footer from '../components/login_register/Footer';
import StudentOrganizationNavbar from '../components/student_organization_profile/StudentOrganizationNavbar';

// The auto-login that used to live here read this.props.match.params.mobile and
// .token, but the /student/payment-success route has no params, so it could
// never run. The user reaching this page is already logged in.
class RazorPaySuccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: 0
        }
    }
    loggedhandleFormSubmit = e => {
        console.log("packageplan", localStorage.getItem("packageplan"));
        if (localStorage.getItem("packageplan") == "home" || localStorage.getItem("packageplan") == "null") {
            this.props.history.push("/student/home");
        }
        if (localStorage.getItem("packageplan") == "mocktest") {
            this.props.history.push("/student/exams/test-series");
        }
        else {
            this.props.history.push("/student/home");
        }

    };

    render() {
        console.log('props',this.props)
        let trasactionID = this.props?.history?.location?.state;
        return (
            <div >
                <StudentOrganizationNavbar name={Cookies.get("studentusername")} />
                <div className="register-form">
                    <section className="register-form-block">
                        <Container>
                            <div className="mb-5">
                                <Row className="mt-5 justify-content-center">
                                    <Col sm={6}>
                                        <Card as={Card.Body} className="border-0 text-center block_white_card">
                                             <Image src={require('../../images/success_img.png')} className="my-2 succes_img" alt="img" />
                                                <h5 className="text-success mb-4 mt-4">Transaction Successful</h5>
                                                <h6>Your Transaction ID : {trasactionID.transactionId}</h6>
                                                <h6 className="mb-4">Thank you for Purchasing</h6>
                                                <Button type="button"  variant="success" className='btn btn-custom-green font-weight-bold mb-5' onClick={this.loggedhandleFormSubmit}>Continue</Button>
                                            
                                        </Card>
                                    </Col>
                                </Row>
                            </div>
                        </Container>
                    </section>
                </div>
            </div>
        )

    }
}
export default withRouter(RazorPaySuccess);
